import { crunchSrcSet } from './utils'
import ZoomableImage from './ZoomableImage'

const ZOOMABLE_THRESHOLD = 900 // for now; ideally it'd be 1_000, but 50% prod images are 900x900 rn.

interface PhotoProps {
  alt: string
  fallbackURL: string
  sizes: string
  srcset: string[]
}

const Photo = ({ alt, fallbackURL, sizes, srcset }: PhotoProps) => {
  const maxSize = parseInt(srcset[srcset.length - 1][1], 10)
  return maxSize < ZOOMABLE_THRESHOLD ? (
    <img
      alt={alt}
      className='c-slider__preview'
      sizes={sizes}
      src={fallbackURL}
      srcSet={crunchSrcSet(srcset)}
    />
  ) : (
    <ZoomableImage
      alt={alt}
      className='c-slider__preview'
      sizes={sizes}
      src={fallbackURL}
      srcset={srcset}
    />
  )
}

export default Photo
